import { Component, OnInit } from '@angular/core';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { UserService } from '../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { RegisterType } from 'src/app/shared/models/enums.model';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.css']
})
export class ActivateAccountComponent implements OnInit {

  code: string = '';
  responseObject: ResponseObject = new ResponseObject();
  showRequest = false;
  showSupplierMessage = false;
  defaultMsgBool = false;
  public RegisterType: any = RegisterType;
  public submitFail: boolean = false;

  constructor(
    private alertService: AlertService,
    private userService: UserService,
    private globalSrv: GlobalServices,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService, ) {
    this.alertService.clear();
    this.code = this.route.snapshot.params.Code;
    this.globalSrv.isLoaderEnabled = true;
    
    this.userService.ActivateAccount(this.code)
      .pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          this.globalSrv.isLoaderEnabled = false;
          this.defaultMsgBool = true;
          if (data.Success) {
            this.showRequest = true;
            this.showSupplierMessage = data.Data == RegisterType.Supplier ? true : false;
          }
          else {
if(data.ErrorMessages[0] == "InternalServerError")
            {this.submitFail= true;}
            this.showRequest = false;
           
          }

        });
  }
  ngOnInit() {
  }
  
  goToHome() {
    this.globalSrv.goToHome();
  }
}
